import type { CompareMode } from "@/analytics/core/types";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/cn";

const COMPARE_OPTIONS: { value: CompareMode; label: string }[] = [
  { value: "prev_period", label: "Prior period" },
  { value: "prev_year", label: "Same period last year" },
];

interface CompareSelectProps {
  value: CompareMode;
  onChange: (mode: CompareMode) => void;
  className?: string;
}

export function CompareSelect({ value, onChange, className }: CompareSelectProps) {
  const selectValue = value === "prev_year" ? "prev_year" : "prev_period";

  return (
    <Select
      value={selectValue}
      onValueChange={(next) => onChange(next === "prev_year" ? "prev_year" : "prev_period")}
    >
      <SelectTrigger className={cn("min-w-44", className)}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {COMPARE_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
